import React from "react";

type IconType = "warning";

export interface IconProps {
    type: IconType
}

export const Icon: React.FC<IconProps> = (props: React.PropsWithChildren<IconProps>) => {
    return <span style={{ color: 'red', fontFamily: '"Source Sans Pro", "Roboto", "San Francisco", "Segoe UI", sans-serif'}}>&#x26A0;</span>;
}